var _defs, _rect, _path, _circle, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#099dfd;stroke-linecap:round;stroke-miterlimit:10;stroke-width:10px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 27.26,
    y: 43.1,
    width: 113.81,
    height: 113.81,
    rx: 32.53
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.74,68.44a31.54,31.54,0,1,0,0,63.07"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 84.16,
    cy: 100,
    r: 31.68
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 172.74,
    y1: 68.44,
    x2: 172.74,
    y2: 131.51
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIconBlue);
export default __webpack_public_path__ + "static/media/video_icon_blue.a09e3496d065a8bf6486e276f147eab1.svg";
export { ForwardRef as ReactComponent };